import { Component, inject, signal } from '@angular/core';
import {
  FormControl,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';

import { Types } from '../../../domain/types.domain';
import { queryParam } from '../../signals';

import { AuthRepositoryInstruction } from '../../../builder/instructions/repositories/auth.repository.instructions';
import { GetPylonCitiesServiceInstruction } from '../../../builder/instructions/services/get-pylon-cities.service.instruction';

@Component({
  selector: 'app-pylon',
  standalone: true,
  imports: [ReactiveFormsModule],
  providers: [
    new AuthRepositoryInstruction(),
    new GetPylonCitiesServiceInstruction(),
  ],
  templateUrl: './pylon.component.html',
  styleUrl: './pylon.component.scss',
})
export class PylonComponent {
  private readonly _router = inject(Router);
  private readonly _settings = inject(Types.Settings);
  private readonly _getPylonCitiesService = inject(Types.GetPylonCitiesService);

  private readonly redirectUriParam = queryParam('redirect_uri');

  public emailFormControl = new FormControl('', [
    Validators.required,
    Validators.email,
  ]);
  public cityFormControl = new FormControl('');

  public loading = signal(false);
  public errorMessage = signal('');
  public cities = signal<{ identity: string; name: string; state: string }[]>(
    []
  );

  async findCities(): Promise<void> {
    this.emailFormControl.markAsTouched();

    if (this.emailFormControl.invalid || this.loading()) {
      return;
    }

    this.loading.set(true);
    this.errorMessage.set('');
    this.cities.set([]);

    try {
      const { cities } = await this._getPylonCitiesService.handle({
        email: this.emailFormControl.value as string,
      });

      if (!cities.length) {
        this.errorMessage.set(
          'Não encontramos uma conta para este e-mail. Verifique o endereço informado.'
        );
        return;
      }

      if (cities.length === 1) {
        this.goToLogin(cities[0].identity);
        return;
      }

      this.cities.set(cities);
    } catch {
      this.errorMessage.set(
        'Não foi possível verificar o e-mail. Tente novamente em instantes.'
      );
    } finally {
      this.loading.set(false);
    }
  }

  selectCity(): void {
    if (this.cityFormControl.value) {
      this.goToLogin(this.cityFormControl.value);
    }
  }

  private goToLogin(cityIdentity: string): void {
    const queryParams: Record<string, string> = {
      redirectTo: `${this._settings.authenticationUrl.v1}/oauth/pylon/callback`,
    };

    const redirectUri = this.redirectUriParam();
    if (redirectUri) {
      queryParams['redirect_uri'] = redirectUri;
    }

    this._router.navigate([`/${cityIdentity}`], { queryParams });
  }
}
